import React from "react";
import { ArrowRight } from "lucide-react";
import { useConsultation } from "../context/ConsultationContext";

export default function ConsultationCTASection({
  eyebrow = "Take the next step",
  title = "Your UAE company, structured by people who've built hundreds before it.",
  copy = "Get a white-glove consultation with a senior StartINC advisor. Zero obligations — just clarity on licensing, tax, banking and residency.",
  service = "other",
}) {
  const { open } = useConsultation();

  return (
    <section
      data-testid="consultation-cta-section"
      className="relative bg-[#002366] text-white py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute -top-24 -right-24 w-[30rem] h-[30rem] rounded-full bg-[#3366FF]/10 blur-3xl pointer-events-none" />
      <div className="container-x relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <p className="overline text-[#6B8AFF]">{eyebrow}</p>
          <div className="gold-rule mt-5 mb-6" />
          <h2 className="font-heading font-light tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight max-w-3xl">
            {title}
          </h2>
          <p className="mt-6 text-slate-300/85 max-w-2xl leading-relaxed">{copy}</p>
        </div>
        <div className="lg:col-span-4 flex lg:justify-end">
          <button
            data-testid="cta-section-button"
            onClick={() => open(service)}
            className="btn-gold w-full lg:w-auto"
          >
            Get a Free Consultation <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
}
